const ENTITY_PATH_PATTERN = /^\/images\/(heroes|units|cards|factions|domains|spells|equipment|uploads|drafts)\//;
const PLACEHOLDER_PATH_PATTERN = /^\/images\/(heroes|units|factions|domains|spells|equipment)\/error\.webp$/;

export function resolveEntityImageUrl(path: string | null | undefined): string {
  if (!path || typeof path !== 'string') return path ?? '';
  if (!ENTITY_PATH_PATTERN.test(path) || PLACEHOLDER_PATH_PATTERN.test(path)) return path;

  const base = (window.gon?.garage_public_base_url ?? '').replace(/\/$/, '');
  if (!base) throw new Error('Missing Garage configuration: GARAGE_PUBLIC_BASE_URL');

  return `${base}${path}`;
}
